export default (theme) => ({
    root: {
        position: 'relative',
        height: '100%',
    },
    header: {
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        height: 60,
        boxShadow: '0 2px 2px 0 rgba(0, 0, 0, 0.05)',
        padding: '0 20px',
    },
    close: {},
    edit: {},
    content: {
        height: 'calc(100% - 60px)',
        overflow: 'overlay',
        ...theme.utils.scrollbar,
        padding: '50px 40px',
        boxSizing: 'border-box',
    },
    box: {
        boxShadow: '0 1px 3px 0 rgba(50, 50, 50, 0.2)',
        '& h1': {
            margin: 0,
        },
        marginBottom: 20,
    },
    boxHeader: {
        height: 40,
        padding: '6.5px 20px',
        backgroundColor: theme.colors.actionMinor[50],
        boxSizing: 'border-box',
        borderBottom: `1px solid ${theme.colors.grey[100]}`,
    },
    boxTitle: {
        color: theme.colors.primary.black,
        lineHeight: '25px',
    },
    boxContent: {
        padding: 20,
    },
    row: {
        display: 'flex',
        flexDirection: 'row',
        '& span': {
            display: 'flex',
            flexDirection: 'row',
        },
        alignItems: 'center',
        height: 40,
    },
    rowTitle: {
        fontWeight: 'bold',
        width: '50%',
        color: theme.colors.primary.black,
    },
    rowText: {
        width: '50%',
    },
});
